export const __TOKEN_KEY__ = '__TOKEN_KEY__';
export const LAST_USER_NAME = 'LAST_USER_NAME';
